<template>
  <v-flex>
  <m-pay-generic-editor
    :loading="loading"
    :bean="widget"
    :beanPropertyValues="beanPropertyValues"
    :beanProperties="editableProperties"
    :validationRules="editableRules"
    @cancel="cancel"
    @submit="submit"
  />
  </v-flex>
</template>

<script>

import MPayGenericEditor from '../MPayGenericEditor';

export default {

  name: 'MPayWidgetEditor',

  props: ['widget', 'loading'],

  components: { MPayGenericEditor },

  data: () => ({

    editableProperties: [
      'name',
      'type',
    ],
    readOnlyProperties: [
      'orderAuthorizationType',
    ],
    editableRules: [
      'required',
      'required',
      'required_if:type,INSTANT',
      'max:255',
      'decimal:2|max_value:1',
    ],
  }),

  computed: {
    merchantId() {
      return this.$route.query.merchant;
    },
    beanPropertyValues() {
      return {
        total_currency: [
          'EUR',
        ],
        type: [
          'CHECKOUT',
          'INSTANT',
          'PAYMENT',
        ],
        orderAuthorizationType: [
          'SIGNATURE',
          'CALLBACK',
          'WIDGET_TOTAL_AMOUNT',
        ],
      };
    },
  },

  methods: {
    submit(bean) {
      const model = Object.assign({}, bean);
      model.merchantId = this.merchantId;
      this.$emit('submit', model);
    },
    cancel() {
      this.$emit('cancel');
    },
  },

};
</script>




// WEBPACK FOOTER //
// src/components/merchant/MPayWidgetEditor.vue